module.exports = __webpack_public_path__ + "static/media/spoon.69f39c18.png";